import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { map, Observable, shareReplay } from 'rxjs';
import { SharedHttpService } from '../../shared/shared-http.service';
import { HealthCheckHttpPaths } from './health-check-http.paths';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckHttpService extends SharedHttpService {
  public healthCheck$: Observable<boolean> = this._http
    .get(this._environment.apiEndpoint + HealthCheckHttpPaths.healthCheck, {
      observe: 'response',
    })
    .pipe(
      map(({ status }) => status === 200),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

  constructor(
    private _http: HttpClient,
    @Inject(SHARED_ENVIRONMENT)
    private _environment: Environment,
  ) {
    super();
  }
}
